<template>
  <v-layout row wrap>
    <form-template title="Strategy Configuration" ref="child-component" :enable-submit="true" @save="onSave" @cancel="onCancel">
      <v-layout row wrap>
        <v-flex xs12 v-if="guidelineDefaultValues.isLoading">
          <v-progress-linear indeterminate></v-progress-linear>
        </v-flex>
        <v-flex xs12 v-if="!guidelineDefaultValues.isLoading">Please provide static values for the guideline cofactors
          below</v-flex>
        <v-flex xs12 v-for="cofactor in cofactors" :key="cofactor.key" pb-3>
          <cofactor-input v-model="cofactor.data"></cofactor-input>
        </v-flex>
      </v-layout>
    </form-template>
    <v-dialog v-model="confirmPartialForm" max-width="500" persistent>
      <v-card>
        <v-card-title class="headline">Not all static cofactor values are set. Are you sure you want to proceed?
        </v-card-title>
        <v-card-text>Warning: Some guidelines may not be able to be calculated if static cofactor values are missing.
          If you would like to fill in missing cofactor information after saving, you can provide the information
          through the configuration window of the cofactor calculation management page.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="add" flat="flat" @click.native="confirmPartialForm=false">{{$t('Button.Cancel')}}</v-btn>
          <v-btn color="add" flat="flat" @click.native="onConfirmSave">{{$t('Button.SaveStrategy')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'
  import {
    algorithms,
  } from '@/helpers/algorithms'
  import FormTemplate from './FormTemplate'
  import CoFactorInput from '@/components/CoFactorManage/CoFactorInput'
  const guidelines = createNamespacedHelpers('guidelines')
  const guidelinesparameter = createNamespacedHelpers('guidelinesparameter')
  const requiredCoFactors = [{
    AnalyteName: 'Temp',
    Units: 'degC',
    Value: null,
    DataFetchStrategy: algorithms.staticOverride.Key,
  },
  {
    AnalyteName: 'pH',
    Units: 'pH',
    Value: null,
    DataFetchStrategy: algorithms.staticOverride.Key,
  },
  {
    AnalyteName: 'Hardness (as CaCO3)',
    Units: 'mg/L',
    Value: null,
    DataFetchStrategy: algorithms.staticOverride.Key,
  },
  ]
  export default {
    components: {
      'form-template': FormTemplate,
      'cofactor-input': CoFactorInput,
    },
    data() {
      return {
        cofactors: [],
        confirmPartialForm: false,
      }
    },
    computed: {
      ...guidelines.mapState(['guidelineDefaultValues']),
      requiredCoFactors() {
        return requiredCoFactors
      },
      isCompleteForm() {
        return this.$refs['child-component'].$refs.form.validate()
      },
    },
    methods: {
      ...guidelines.mapActions(['putGuidelineAnalyteDefaultValuesByBatch']),
      ...guidelinesparameter.mapActions(['getGuidelineAnalyteDefaultValues']),
      onSave() {
        if (this.isCompleteForm) {
          this.onConfirmSave()
        } else {
          this.confirmPartialForm = true
        }
      },
      onConfirmSave() {
        this.confirmPartialForm = false
        this.saveDefaultValues()
      },
      onCancel() {
        this.$emit('cancel')
      },
      initializeCoFactors(existingData) {
        this.cofactors = []
        this.requiredCoFactors.forEach(cf => {
          let dataTemplate = JSON.parse(JSON.stringify(cf))
          let data = existingData.find(
            d => d.AnalyteName == cf.AnalyteName
          )
          if (data && data.Units && data.Value) {
            dataTemplate.Id = data.Id
            dataTemplate.Units = data.Units
            dataTemplate.Value = data.Value
          }
          this.cofactors.push({
            key: cf.AnalyteName,
            data: dataTemplate,
          })
        })
      },
      saveDefaultValues() {
        let that = this
        let options = {
          payload: this.cofactors.map(cf => cf.data),
          successCb() {
            that.$emit('save')
          },
          failedCb(msg) {
            console.error(msg)
            that.$emit('notify', {
              type: 'error',
              message: `failed to save default values: ${msg}`,
            })
          },
        }
        this.putGuidelineAnalyteDefaultValuesByBatch(options)
      },
      fetchDefaultValues(forced, cb) {
        let that = this
        let options = {
          params: {
            strategy: algorithms.staticOverride.Key,
          },
          forced: forced || false,
          successCb(data) {
            cb(data)
          },
          failedCb(msg) {
            console.error(msg)
            that.$emit('notify', {
              type: 'error',
              message: `failed to fetch co factor strategy form: ${msg}`,
            })
          },
        }
        this.getGuidelineAnalyteDefaultValues(options)
      },
    },
    mounted() {
      let that = this
      this.fetchDefaultValues(true, d => that.initializeCoFactors(d))
    },
  }
</script>

<style scoped lang="stylus"></style>